import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Button, Card, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Axios from "axios";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as ControllerStyles from "../styles/controller";

function Controller() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [events, setEvents] = useState([]);

    const [modalYN, setModalYN] = useState({
        open: false,
        heading: "",
        message: "",
        acceptFunction: "",
        acceptName: "",
        showAccept: false,
        cancelName: "",
        showCancel: false
    });

    function handleModalYNClose() {
        setModalYN((prevState) => {
            return { ...prevState, open: false };
        });
    }

    useEffect(() => {
        dispatch(GS_navSettingsActions.UpdateTitle("Calendar"));
        dispatch(GS_navSettingsActions.UpdateSelected("Features"));
        dispatch(GS_navSettingsActions.UpdateSubSelected("Calendar"));
        getEvents();
    }, []);

    function getEvents() {
        Axios.post("/pods/calendar/getEvents")
            .then((res) => {
                const data = res.data;
                setEvents(data.events);
            })
            .catch((err) => console.log(err));
    }

    function handleNewEventClick() {
        navigate("./newEvent");
    }
    function handleEventClick(id) {
        navigate(`./modifyEvent/${id}`);
    }

    function handleDeleteClick(uuid) {
        setModalYN({
            heading: "Delete Event",
            message: "Are you sure you want to delete this event?",
            showAccept: true,
            acceptName: "Yes",
            acceptFunction: acceptDelete.bind(this, uuid),
            showCancel: true,
            cancelName: "No",
            open: true
        });
    }

    function acceptDelete(uuid) {
        const data = { uuid: uuid };
        Axios.post("/pods/calendar/deleteEvent", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setModalYN((prevState) => {
                        return { ...prevState, open: false };
                    });
                    getEvents();
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div style={ControllerStyles.body}>
            <Row>
                <Col style={ControllerStyles.newEventBtn}>
                    <Button onClick={handleNewEventClick}>New Event</Button>
                </Col>
            </Row>
            <Row style={ControllerStyles.topRow}>
                <Col>
                    <Card style={ControllerStyles.cardBody}>
                        <Card.Body>
                            <Row>
                                <Col sm={11}>
                                    <Row>
                                        <Col>Title</Col>
                                        <Col>Start Date</Col>
                                        <Col>Start Time</Col>
                                        <Col>End Time</Col>
                                    </Row>
                                </Col>
                                <Col></Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <br />
            <Row>
                <Col>
                    <div style={ControllerStyles.eventsBox}>
                        {events.map((event, index) => {
                            return (
                                <div key={index}>
                                    <Card style={ControllerStyles.cardBody}>
                                        <Card.Body>
                                            <Row>
                                                <Col sm={11} onClick={handleEventClick.bind(this, event.uuid)}>
                                                    <Row>
                                                        <Col>{event.title}</Col>
                                                        <Col>{event.startDate}</Col>
                                                        <Col>{event.timeType == "allDay" ? "All Day" : event.startTime}</Col>
                                                        <Col>{event.timeType != "allDay" && event.endTime}</Col>
                                                    </Row>
                                                </Col>

                                                <Col style={ControllerStyles.columnRight}>
                                                    <Button variant="danger" onClick={handleDeleteClick.bind(this, event.uuid)}>
                                                        <i className="fa-solid fa-trash-can"></i>
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                    <br />
                                </div>
                            );
                        })}
                    </div>
                </Col>
            </Row>
            <Modal show={modalYN.open} onHide={handleModalYNClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalYN.heading}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalYN.message}</Modal.Body>
                <Modal.Footer>
                    {modalYN.showAccept ? (
                        <div>
                            <Button variant="primary" onClick={modalYN.acceptFunction}>
                                {modalYN.acceptName}
                            </Button>
                        </div>
                    ) : null}
                    {modalYN.showCancel ? (
                        <div>
                            <Button variant="primary" onClick={handleModalYNClose}>
                                {modalYN.cancelName}
                            </Button>
                        </div>
                    ) : null}
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default Controller;
